// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"9291":"3812924d520899b5c9f4","9551":"ad50a950026c0cfc30e2"}[chunkId] + "";
};